import React from 'react';
import { pick } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import { ReadMore } from 'js/components/common/ReadMore';
import style from './index.scss';

export default ({ children, showDetails, lines = 4 }) => {
    const { isPortrait, isMobile } = useDeviceSelector(pick(['isPortrait', 'isMobile']));
    const defaultShowDetails = isPortrait && isMobile;

    return showDetails != null ? showDetails : defaultShowDetails
        ? <ReadMore lines={lines}>{children}</ReadMore>
        : <p className={style.body}>{children}</p>;
};
